import React, { useState } from "react";
import { Form, Spin, Typography, notification, Modal } from "antd";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SponsorForm from "../components/SponsorForm";
import axios from "axios";

const { Title } = Typography;

export default function CreateUser() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [sponsorData, setSponsorData] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);

  const handleSponsorFinish = async (values) => {
    try {
      setLoading(true);

      const endpoint =
        "https://verimedramja.pythonanywhere.com/verimed/user_create/";
      const headers = {
        "Content-Type": "multipart/form-data",
      };

      const formData = new FormData();
      const userSignupData = {
        first_name: values.first_name,
        last_name: values.last_name,
        role: "sponsor",
        email: values.email,
        countrycode: values.countrycode || "IN",
        phone: values.phone,
        password: values.password,
        is_active_state: true,
      };

      formData.append("user_signup", JSON.stringify(userSignupData));

      if (values.photo && values.photo.length > 0) {
        formData.append("photo", values.photo[0].originFileObj);
      }

      const res = await axios.post(endpoint, formData, { headers });
      fetchSelectedSponsor(res.data.sponsor_id);

      if (res.status === 200 || res.status === 201) {
        setModalVisible(true);
        form.resetFields();
        setFileList([]);
        // setTimeout(() => setCurrentStep(1), 500);
      } else {
        notification.error({
          message: "Error Creating Sponsor",
          description: res.data?.message || "Please try again.",
          placement: "topRight",
        });
      }
    } catch (error) {
      console.error("Error creating sponsor:", error);
      notification.error({
        message: "Failed to Create Sponsor",
        description: error.response?.data?.detail || "Something went wrong.",
        placement: "topRight",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchSelectedSponsor = async (sponsorId) => {
    try {
      const endpoint =
        "https://verimedramja.pythonanywhere.com/verimed/sponsorprofile_list/";
      const headers = {
        Authorization: "Token 7d406eecd7d9be342a7dbad264a73c5ac761f19a",
      };
      const res = await axios.get(endpoint, { headers });
      const selectedSponsorId = res.data.find(
        (sponsor) => sponsor.sponsor_id === sponsorId,
      );
      setSponsorData(selectedSponsorId);
    } catch (error) {
      console.log("Error fetching sponsor details:", error);
    }
  };

  const handlePatientInfoFinish = async (values) => {
    console.log("Patient Info Submitted:", values);

    const formData = new FormData();

    // ---- MAIN JSON OBJECT ----
    const patientprofile_data = {
      sponsorid: sponsorData?.id,
      caretakerid: values.caretakerid || null,
      patient_name: values.patient_name,
      country_code: values.country_code,
      phone: values.phone,
      patient_dob: values.patient_dob,
      patient_gender: values.patient_gender,
      blood_group: values.blood_group,
      patient_home_address: values.patient_home_address,
      primary_language: values.primary_language,
      religion: values.religion,
      escalate_to_physician: values.escalate_to_physician,
      emer_con_name: values.emer_con_name,
      emer_con_relation: values.emer_con_relation,
      emer_con_coun_of_residen: values.emer_con_coun_of_residen,
      emer_con_country_code: values.emer_con_country_code,
      emer_con_phone: values.emer_con_phone,
      emer_con_email: values.emer_con_email,
      local_con_name: values.local_con_name,
      local_con_relation: values.local_con_relation,
      local_con_country_code: values.local_con_country_code,
      local_con_phone: values.local_con_phone,
      reason_enrollment: values.reason_enrollment,
      reason_other: values.reason_other,
      medical_his_diagnosis: values.medical_his_diagnosis,
      medical_his_cancer: values.medical_his_cancer,
      medical_his_other: values.medical_his_other,
      medical_his_provided_medi_care: values.medical_his_provided_medi_care,
      medical_his_major_surgeries: values.medical_his_major_surgeries,
      medical_his_curr_symp: values.medical_his_curr_symp,
      medication_name: values.medication_name,
      medication_dose: values.medication_dose,
      medication_frequency: values.medication_frequency,
      medication_reason: values.medication_reason,
      medication_issues: values.medication_issues,
      medication_issues_explain: values.medication_issues_explain,
      allergies_issues: values.allergies_issues,
      allergies_drug: values.allergies_drug,
      allergies_food: values.allergies_food,
      functional_bathe: values.functional_bathe,
      functional_dress: values.functional_dress,
      functional_eat: values.functional_eat,
      functional_walk: values.functional_walk,
      functional_use_bathroom: values.functional_use_bathroom,
      functional_daily_activity: values.functional_daily_activity,
      functional_manage_finance: values.functional_manage_finance,
      functional_any_falls: values.functional_any_falls,
      functional_how_many: values.functional_how_many,
      functional_memory_pbms: values.functional_memory_pbms,
      lifestyle_daily_routine: values.lifestyle_daily_routine,
      lifestyle_dietary_habits: values.lifestyle_dietary_habits,
      lifestyle_sleep_quality: values.lifestyle_sleep_quality,
      lifestyle_physical_activity: values.lifestyle_physical_activity,
      lifestyle_alcohol_use: values.lifestyle_alcohol_use,
      lifestyle_pain_complaints: values.lifestyle_pain_complaints,
      lifestyle_pain_where: values.lifestyle_pain_where,
      social_emotion_health: values.social_emotion_health,
      social_spiritual_needs: values.social_spiritual_needs,
      social_trusted_person: values.social_trusted_person,
      social_name: values.social_name,
      goals_family_hope: values.goals_family_hope,
      goals_special_instructions: values.goals_special_instructions,
      goals_term_membership: values.goals_term_membership,
    };

    // ---- APPEND MAIN JSON ----
    formData.append("patientprofile_data", JSON.stringify(patientprofile_data));

    // ---- FILE IDs & NAMES ----
    if (values.patient_files_ids) {
      formData.append("patient_files_ids", values.patient_files_ids);
    }

    if (values.patient_files_name) {
      formData.append("patient_files_name", values.patient_files_name);
    }

    // ---- MULTIPLE FILE UPLOADS ----
    if (values.patient_upload_files && values.patient_upload_files.length > 0) {
      values.patient_upload_files.forEach((file) => {
        formData.append("patient_upload_files", file.originFileObj || file);
      });
    }

    // ---- SINGLE PHOTO ----
    if (values.patient_photo && values.patient_photo.length > 0) {
      formData.append("patient_photo", values.patient_photo[0].originFileObj);
    }

    try {
      setLoading(true);
      const response = await axios.post(
        "https://verimedramja.pythonanywhere.com/verimed/patientprofile_create_update/",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      notification.success({
        message: "Patient Information Saved",
        description: "All steps completed successfully.",
        placement: "topRight",
      });

      console.log("Patient Info Response:", response.data);
      form.resetFields();
    } catch (error) {
      console.error("Error updating patient info:", error);
      notification.error({
        message: "Update Failed",
        description:
          error.response?.data?.message ||
          "Something went wrong while updating patient info.",
        placement: "topRight",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create_user_container">
      <Header />

      <div className="create_user_content">
        {/* Step Indicator */}
        {/*
    <div className="step_indicator_container">
      {steps.map((step, index) => (
        <div key={index} className="step_item">
          <div
            className={`step_circle ${
              index === currentStep ? "step_circle_active" : "step_circle_inactive"
            }`}
          >
            {step}
          </div>
          {index < steps.length - 1 && <div className="step_line" />}
        </div>
      ))}
    </div>
    */}

        {/* Title */}
        <Title level={4} className="create_user_title">
          Register Here
          {/* {currentStep === 0
            ? "Step 1: Create Sponsor User ID"
            : "Step 2: Patient Information"} */}
        </Title>

        {/* Form */}
        {/* {currentStep === 0 && ( */}
        <SponsorForm
          form={form}
          loading={loading}
          onFinish={handleSponsorFinish}
        />
        {/* )} */}
        {/* {currentStep === 1 && (
          <PatientInformationForm
            form={form}
            onFinish={handlePatientInfoFinish}
          />
        )} */}
      </div>
      <Modal
        title="Success"
        visible={modalVisible}
        onOk={() => {
          setModalVisible(false);
          window.location.href = "https://verimed-dashboard.vercel.app/";
        }}
        onCancel={() => setModalVisible(false)}
      >
        <p>
          sponsor created successfully kindly continue to login using username
          and password received to your given email
        </p>
      </Modal>
      <Footer />
    </div>
  );
}
